module.exports = __webpack_public_path__ + "img/person4.5cbc6703.png";